// initial state
import * as base from './base.js'
const baseName = '/admin/backstageLog'



const labelList = baseName + '/list'
const labelAdd = baseName + '/add'
const labelEdit = baseName + '/edit'



const obj = base.setBaseUrl('backstageLog', baseName)
const obj1 = base.setBaseUrl('backstageLogList', labelList)
const obj2 = base.setBaseUrl('backstageLogAdd', labelAdd)
const obj3 = base.setBaseUrl('backstageLogEdit', labelEdit)


const a = Object.assign(obj, obj1, obj2, obj3,{ labelList, labelAdd,labelEdit})
export default a
